import ReactDOM from "react-dom/client";
import Dialog from "../components/dialog/Dialog";
import {capitalize} from "./strings";

export function displayDialogMessage(title, description, okTitle = "OK", onOkAction = () => {}) {
    const modalRoot = document.createElement("div");
    document.body.appendChild(modalRoot);
    const root = ReactDOM.createRoot(modalRoot);

    function closeModal() {
        root.unmount();
        document.body.removeChild(modalRoot);
    }

    function okHandler() {
        onOkAction();
        closeModal();
    }

    root.render(
        <Dialog
            title={title}
            description={description}
            confirmTitle={capitalize(okTitle)}
            confirmHandler={okHandler}
            className="w-1/2"
        />
    );
}
